module.exports = __webpack_public_path__ + "static/media/mars-r.6a3ee184.mp3";